// src/constants.js
export const PRIORITY_LEVELS = ["Low", "Medium", "High"];

export const PRIORITY_COLORS = {
  Low: "green",
  Medium: "orange",
  High: "red",
};

export const TICKET_TYPES = [
  "Incident",
  "Problem",
  "Question",
  "Suggestion",
  "Evolution",
  "Bug",
  "Feature",
  "Improvement",
  "ChangeRequest",
  "Task",
];
